import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'


const incomingCargo = {
  firestorePath: '/incoming-cargos',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'incomingCargo',
  statePropName: 'incomingCargo',
  namespaced: true, // automatically added
  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions

  state, getters, mutations, actions
}

export default incomingCargo